import { useQuery } from '@tanstack/react-query';

import { useStoreApi } from '../../api';
import { storeKeys } from '../../query-key-factory';
import { ConsumerCartItemResponse } from './types';

export function useShowConsumerCartItem({ cartItemId }: { cartItemId?: string }) {
  const StoreApi = useStoreApi();
  const getCartItem = async () => {
    const { data } = await StoreApi.get<ConsumerCartItemResponse>(
      `/consumer/cart_items/${cartItemId}`
    );
    return data.cart_item;
  };

  const key = cartItemId ? storeKeys.id('user').consumer.cartItems.id(cartItemId).detail : [];

  return useQuery({
    queryKey: key,
    queryFn: getCartItem,
    enabled: !!cartItemId,
  });
}
